<template>
<div class="chapter">
<div class="inner_page">
<span epub:type="pagebreak" id="page36" title="36">
<h1 class="recipe-title" id="AA3">GARDEN VEGGIE FRITTATA</h1>
<p class="recipe-headnote">This colorful garden veggie–filled frittata cooks up light and fluffy. Full of vitamin A–rich carrots, superfood kale, and plenty of cheesy, savory spices, this soy-based frittata is a healthy entrée for a veggie-filled breakfast. Make it in advance and simply warm to reheat and serve. Have a brunch garden party and let this be the star of your table.</p>
<p class="yield">MAKES ONE 9- TO 10-INCH FRITTATA; SERVES 6</p>
<h2 class="ing-hed">TOFU BASE</h2>
<ul class="ing-list">
<li class="ingred">18 ounces silken tofu</li>
<li class="ingred">½ cup nutritional yeast</li>
<li class="ingred">2½ tablespoons arrowroot powder or cornstarch</li>
<li class="ingred">1 tablespoon tahini or almond butter</li>
<li class="ingred">1½ teaspoons ground turmeric</li>
<li class="ingred">1 teaspoon sea salt</li>
<li class="ingred">½ teaspoon garlic powder</li>
<li class="ingred">½ teaspoon freshly ground black pepper</li>
</ul>
<h2 class="ing-hed">VEGGIES</h2>
<ul class="ing-list">
<li class="ingred">1 teaspoon extra-virgin olive oil</li>
<li class="ingred">½ cup diced zucchini</li>
<li class="ingred">½ cup diced carrot</li>
<li class="ingred">¼ cup diced portobello or shiitake mushrooms</li>
<li class="ingred">3 cups chopped kale</li>
</ul>
<h2 class="ing-hed">TOPPINGS</h2>
<ul class="ing-list">
<li class="ingred">½ cup canned diced fire-roasted tomatoes or diced fresh tomatoes</li>
<li class="ingred">Handful of vegan cheddar cheese (optional)</li>
<li class="ingred">3 tablespoons sliced black olives</li>
<li class="ingred">Sprinkle of freshly ground black pepper</li>
</ul>
<table class="method">
<tbody><tr><td class="stepnum"><p class="step-num">1</p></td>
<td><p class="step">Preheat the oven to 375°F. Grease a 9- to 10-inch round baking pan. You could also use a cast-iron skillet.</p></td></tr>
<tr><td class="stepnum"><p class="step-num">2</p></td>
<td><p class="step"><strong class="step-leadin">For the Tofu Base:</strong> In a blender or food processor, combine the tofu base ingredients and blend until smooth. Pour the mixture into a large bowl.</p></td></tr>
<tr><td class="stepnum"><p class="step-num">3</p></td>
<td><p class="step"><strong class="step-leadin">For the Veggies:</strong> In a skillet, heat the oil over high heat. Add the zucchini, carrot, and mushrooms and cook, stirring, until the edges are browned. Fold in the kale and cook until it has wilted. Remove the pan from the heat.</p></td></tr>
<tr><td class="stepnum"><p class="step-num">4</p></td>
<td><p class="step">Fold the warm veggie mixture into the tofu base. Pour the mixture into the prepared baking pan. Top with the tomatoes, vegan cheese (if using), olives, and pepper.</p></td></tr>
<tr><td class="stepnum"><p class="step-num">5</p></td>
<td><p class="step">Bake until the top and edges of the frittata are nice and browned, about 1 hour. Let the frittata cool in the pan on a wire rack for at least 30 minutes before serving. You can make this dish a day ahead of time, store it in the refrigerator, covered, and reheat in the oven to serve. </p></td></tr>
</tbody></table>
<div class="fact">
<h2 class="nutr-hed">NUTRITION FACTS</h2>
<p class="nutr-param">(per serving–193g)</p>
<p class="nutr">Calories: 169; Fat: 6g; Carbs: 18g; Protein: 14g; Fiber: 6g<br/>Vitamin C: 76%; Iron: 28%; Calcium: 10%; Vitamin A: 138%</p>
</div>
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page036.vue?49818ed4